module.exports = __webpack_public_path__ + "static/media/movr-logo.18fee414.png";